export default "My own take on a beloved classic of my childhood, Minesweeper.\n[mines.mike-moe.com](https://mines.mike-moe.com/)"